import { TextareaAutosize } from "@mui/material";
import Box from "@mui/material/Box";

export default function TextAreaComponent({ propsData, name }) {
  const { handleChange, values } = propsData;

  const sendDataToParent = (event) => {
    handleChange(event);
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { width: "100%" },
      }}
      noValidate
      autoComplete="off"
    >
      <TextareaAutosize
        onChange={sendDataToParent}
        value={values[name]}
        name={name}
        maxRows={1}
        className="textArea"
      />
    </Box>
  );
}
